// @flow
import React, { Component } from 'react'
import Axios from 'axios'
import { Row, Col } from 'antd'

type Props = {
  symbol: string
}

type State = {
  newsLatters: Object[],
  error: null | string,
  isLoading: boolean
}

class News extends Component<Props, State> {

  state: State = {
    newsLatters: [],
    error: null,
    isLoading: true
  }

  componentDidMount() {

    this.getNewsData()
  }

  getNewsData = async () => {

    const { symbol } = this.props

    try {

      const range = 5
      const response = await Axios.get(`https://cloud.iexapis.com/v1/stock/${symbol}/news/last/${range}?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`)

      if (response && response.data && Array.isArray(response.data)) {

        this.setState({
          newsLatters: response.data,
          error: null,
          isLoading: false
        })

      } else {

        this.setState({
          isLoading: false,
        })
      }

    } catch(err) {

      this.setState({
        error: 'something went wrong',
        isLoading: false
      })
    }
  }

  render() {

    const {
      newsLatters,
      isLoading
    } = this.state

    return (
      <Row>
        { isLoading ?
          <div>Loading....</div> :
          <div>
            <h4><b>News</b></h4>
            {
              newsLatters.map((news,i) => {
                const relatedTo = (news.related && news.related.split(',')) || []
                return (
                  <Row key={i} className='mb-5'>
                    <Col span={24}>
                      <p><small>{`${news.datetime} | ${news.source}`}</small></p>
                      <a href={news.url} className='text-dark' target='_blank'>
                        <h5 className='font-weight-bold'>{news.headline}</h5>
                        <p>{news.summary}</p>
                      </a>
                      <div>
                        Related:
                        {
                          relatedTo.map(tag => (
                            <a key={tag} href={`/stocks/${tag}`} className='d-inline btn rounded text-primary p-1 m-1 bg-light'><small>{tag}</small></a>
                          ))
                        }
                      </div>
                    </Col>
                  </Row>
                )
              })
            }
          </div>
        }
      </Row>
    )
  }
}

export default News



// WEBPACK FOOTER //
// ./src/components/view-news/index.js